import axios, { Method } from 'axios';
import { useEffect, useState } from 'react';

const useRequest = (
  url: string,
  params?: Record<string, any>,
  options?: { shouldFetch?: boolean; method?: Method },
): { data: any; isValidating: boolean } => {
  const [data, setData] = useState();
  const [isValidating, setIsValidating] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      if (!!options && !options.shouldFetch) {
        return;
      }

      setIsValidating(true);

      const { data } = await axios({
        url,
        method: options?.method || 'GET',
        ...(options?.method === 'POST' && { data: params }),
        ...(options?.method !== 'POST' && { params }),
      });

      setData(data);
      setIsValidating(false);
    };

    fetch();
  }, [options, params, url]);

  // useEffect(() => {
  //   if (!shouldFetch || !!data) {
  //     return;
  //   }

  //   fetchData();
  // }, [data, fetchData, shouldFetch]);

  // useEffect(() => {
  //   fetchData();
  // }, [params]);

  return { data, isValidating };
};

export default useRequest;
